/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EsercenteProfiloCreationForm { 
    email: string;
    ragione_sociale: string;
    partita_iva: string;
    pec?: string;
    sede_legale?: string;
    indirizzo_sede?: string;
    iban?: string;
    cciaa?: string;
    comune_riferimento_id?: string;
}

